var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 36,
    viewBox: "0 0 130 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tags=shenhezhong"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 39854",
    d: "M4.61651e-05 0H112C121.941 0 130 8.05887 130 18V18C130 27.9411 121.941 36 112 36H0L4.61651e-05 0Z",
    fill: "#E7F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xAE\xA1\xE6\xA0\xB8\xE4\xB8\xAD",
    d: "M20.136 10.936V13.944H22.056V12.76H31.832V13.944H33.832V10.936H20.136ZM25.608 9.768C25.864 10.328 26.152 11.112 26.296 11.592L28.392 10.968C28.232 10.504 27.88 9.768 27.608 9.224L25.608 9.768ZM21.064 14.536V22.52H22.92V16.2H30.984V22.44H32.92V14.536H21.064ZM22.248 17.352V18.952H31.976V17.352H22.248ZM22.248 20.12V21.784H32.056V20.12H22.248ZM25.96 13.176V24.424H27.976V13.176H25.96ZM41.256 11.72V13.464H50.424V11.72H41.256ZM44.92 9.496V12.632H46.808V9.496H44.92ZM45.992 21.32C47.064 22.28 48.44 23.656 49.08 24.488L50.632 23.304C49.928 22.456 48.472 21.16 47.448 20.28L45.992 21.32ZM41.384 15.944C42.536 16.76 44.024 17.976 44.696 18.792L45.864 17.288C45.144 16.504 43.592 15.368 42.472 14.632L41.384 15.944ZM44.696 12.568C44.232 13.576 43.368 14.952 42.68 15.816L44.056 16.536C44.792 15.752 45.736 14.52 46.584 13.416L44.696 12.568ZM48.744 17.352C47.16 20.072 44.152 21.896 40.648 22.872C41.08 23.304 41.544 23.96 41.784 24.44C45.544 23.208 48.6 21.192 50.472 18.072L48.744 17.352ZM47.528 14.216C46.216 16.632 43.752 18.616 41.08 19.72C41.496 20.088 42.008 20.696 42.248 21.128C45.144 19.736 47.624 17.608 49.192 14.888L47.528 14.216ZM35.704 12.712V14.504H41.16V12.712H35.704ZM37.752 9.416V24.44H39.528V9.416H37.752ZM37.72 13.944C37.32 15.992 36.376 18.488 35.336 19.88C35.624 20.344 36.04 21.096 36.216 21.624C37.384 19.976 38.344 16.888 38.808 14.328L37.72 13.944ZM39.448 15.224L38.616 16.024C39.08 16.84 40.088 18.712 40.488 19.704L41.528 18.264C41.224 17.784 39.832 15.672 39.448 15.224ZM52.392 12.2V20.312H54.328V14.088H63.608V20.232H65.624V12.2H52.392ZM53.4 17.528V19.416H64.728V17.528H53.4ZM57.944 9.416V24.44H59.976V9.416H57.944Z",
    fill: "#3E7EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 112,
    cy: 18,
    r: 14,
    fill: "#3E7EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 66",
    d: "M119 11.875V18C119 17.3957 118.923 16.8093 118.779 16.25C118.002 13.2309 115.262 11 112 11C108.134 11 105 14.134 105 18C105 21.866 108.134 25 112 25C114.591 25 116.853 23.5923 118.064 21.5",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 93",
    d: "M112 15V17.5H115",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShz);
export default __webpack_public_path__ + "static/media/shz.2a813a3dd50a07530e575e74b826321a.svg";
export { ForwardRef as ReactComponent };